<template>
  <el-dialog title="转发给" :visible.sync="show" width="460px" :before-close="close">
    <el-scrollbar style="height: 380px;">
      <div class="forward-item" v-for="target in targets" :key="target.key"
        @click="onSelect(target)">
        <head-image :size="36" :name="target.name" :url="target.headImage" :is-show-user-info="false"></head-image>
        <span class="target-name">{{ target.name }}</span>
        <span class="target-type">{{ target.typeText }}</span>
        <i v-if="target.checked" class="el-icon-check" style="color: #409eff;"></i>
      </div>
    </el-scrollbar>
    <span slot="footer" class="dialog-footer">
      <el-button @click="close()">取 消</el-button>
      <el-button type="primary" :disabled="!checkedCount" @click="confirm()">确定({{ checkedCount }})</el-button>
    </span>
  </el-dialog>
</template>

<script>
import HeadImage from "../common/HeadImage.vue";

export default {
  name: "forwardMessage",
  components: { HeadImage },
  data() {
    return {
      show: false,
      targets: []
    }
  },
  computed: {
    checkedCount() {
      return this.targets.filter(t => t.checked).length;
    }
  },
  methods: {
    open() {
      this.show = true;
      this.initTargets();
    },
    close() {
      this.show = false;
    },
    initTargets() {
      this.targets = [];
      // 好友
      this.friendStore.friends.filter(f => !f.deleted).forEach(f => {
        this.targets.push({
          key: 'p_' + f.id,
          type: this.$enums.CONVERSATION_TYPE.PRIVATE,
          targetId: f.id,
          name: f.nickName,
          headImage: f.headImage,
          typeText: '好友',
          checked: false
        });
      });
      // 群聊
      this.groupStore.groups.filter(g => !g.quit).forEach(g => {
        this.targets.push({
          key: 'g_' + g.id,
          type: this.$enums.CONVERSATION_TYPE.GROUP,
          targetId: g.id,
          name: g.showGroupName,
          headImage: g.headImageThumb,
          typeText: '群聊',
          checked: false
        });
      });
    },
    onSelect(target) {
      target.checked = !target.checked;
    },
    confirm() {
      const checked = this.targets.filter(t => t.checked);
      this.$emit('complete', checked);
      this.show = false;
    }
  }
}
</script>

<style lang="scss" scoped>
.forward-item {
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 8px 4px;
  border-bottom: 1px solid #f0f0f0;
  cursor: pointer;

  &:hover {
    background: var(--im-background-active);
  }

  .target-name {
    flex: 1;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }

  .target-type {
    font-size: 12px;
    color: #999;
  }
}
</style>
